import { render, staticRenderFns } from "./ModalFormularioCostosPrograma.vue?vue&type=template&id=b0a340c6&scoped=true"
import script from "./ModalFormularioCostosPrograma.vue?vue&type=script&lang=js"
export * from "./ModalFormularioCostosPrograma.vue?vue&type=script&lang=js"
import style0 from "./ModalFormularioCostosPrograma.vue?vue&type=style&index=0&id=b0a340c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0a340c6",
  null
  
)

export default component.exports